import { Controller } from "stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['introPart', 'articlePart', 'opinionPart', 'exercisesPart',
                    'feedbackPart', 'feedbackNotice', 'feedbackForm', 'feedbackInput', 'feedbackSubmit']

  initialize() {
    this.checkParts()

    this.introPartTarget.addEventListener('sectioncomplete', (event) => {
      this.markAsDone(this.introPartTarget)
      this.triggerPartReady(this.articlePartTarget)
    })

    this.articlePartTarget.addEventListener('sectioncomplete', (event) => {
      this.markAsDone(this.articlePartTarget)
      this.triggerPartReady(this.opinionPartTarget)
    })

    this.opinionPartTarget.addEventListener('sectioncomplete', (event) => {
      this.markAsDone(this.opinionPartTarget)
      this.triggerPartReady(this.exercisesPartTarget)
    })

    this.exercisesPartTarget.addEventListener('sectioncomplete', (event) => {
      this.markAsDone(this.exercisesPartTarget)
      this.triggerPartReady(this.feedbackPartTarget)
      this.enableFeedback()
    })

    this.exercisesPartTarget.addEventListener('sectionincomplete', (event) => {
      this.markAsTbd(this.exercisesPartTarget)
      this.disableFeedback()
    })
  }

  triggerPartReady(part) {
    if (part.dataset.status === 'tbd' && part.dataset.sectionExpand !== 'open') {
      Rails.fire(part, 'sectionready')
    }
  }

  markAsDone(part) {
    part.classList.remove('card-tbd')
    part.classList.add('card-done')
    part.dataset.done = 'done'
  }

  markAsTbd(part) {
    part.classList.remove('card-done')
    part.classList.add('card-tbd')
    part.dataset.done = 'tbd'
  }

  checkParts() {
    let done = true

    if (this.introPartTarget.dataset.status !== 'done') { done = false }
    if (this.articlePartTarget.dataset.status !== 'done') { done = false }
    if (this.opinionPartTarget.dataset.status !== 'done') { done = false }
    if (this.exercisesPartTarget.dataset.status !== 'done') { done = false }

    if (done) {
      this.enableFeedback()
    } else {
      this.disableFeedback()
    }
  }

  enableFeedback() {
    this.feedbackNoticeTarget.classList.add('d-none')
    this.feedbackFormTarget.classList.remove('o-30')
    this.feedbackSubmitTarget.classList.remove('d-none')
    this.feedbackInputTargets.forEach(input => { input.disabled = false })
  }

  disableFeedback() {
    this.feedbackNoticeTarget.classList.remove('d-none')
    this.feedbackFormTarget.classList.add('o-30')
    this.feedbackSubmitTarget.classList.add('d-none')
    this.feedbackInputTargets.forEach(input => { input.disabled = true })
  }
}
